import React, { useState } from 'react';
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from '@material-ui/core';

const MODE_COPY = {
    flex: {
        title: 'Desactivar modo Flex',
        getMessage: (companyName) => (
            <>
                ¿Deseás desactivar el modo <b>Flex</b> para <b>{companyName}</b>?
                <Box component={'span'} display={'block'} style={{ marginTop: 12 }}>
                    También se desactivarán las features de coworkings en los países de la empresa.
                </Box>
            </>
        ),
        confirmLabel: 'Sí, desactivar Flex'
    },
    semi_flex: {
        title: 'Desactivar modo Semi-Flexible',
        getMessage: (companyName) => (
            <>
                ¿Deseás desactivar el modo <b>Semi-Flexible</b> para <b>{companyName}</b>?
            </>
        ),
        confirmLabel: 'Sí, desactivar Semi-Flexible'
    }
};

const CompanyModeToggleConfirmModal = ({
    open,
    modeType,
    company,
    onClose,
    onConfirm
}) => {
    const [loading, setLoading] = useState(false);
    const copy = MODE_COPY[modeType] || MODE_COPY.flex;

    const handleClose = () => {
        if (loading) return;
        if (onClose) onClose();
    };

    const handleConfirm = async () => {
        setLoading(true);
        try {
            if (onConfirm) await onConfirm();
            window.location.reload();
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    return (
        <Dialog open={Boolean(open && company && modeType)} onClose={handleClose} maxWidth={'sm'} fullWidth>
            <DialogTitle>{copy.title}</DialogTitle>
            <DialogContent>
                <Typography component={'div'} variant={'body1'}>
                    {copy.getMessage(company?.name || 'esta empresa')}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color={'default'} disabled={loading}>
                    Cancelar
                </Button>
                <Button
                    onClick={handleConfirm}
                    color={'primary'}
                    variant={'contained'}
                    disabled={loading}
                    startIcon={loading ? <CircularProgress color={'inherit'} size={18} /> : null}
                >
                    {loading ? 'Procesando...' : copy.confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CompanyModeToggleConfirmModal;
